var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useGlobalContext, currentTripStateIdVar, usePageRouting, TripType, } from '@honeycomb/data';
import { Timeline, Styler, TypographyBody, FlexGrid, Button, Dialog, DialogContent, DialogHeader, } from '@honeycomb/ui-core';
import { trackFunnelAction, FunnelAction } from '@honeycomb/tracking';
import { DateTime } from 'luxon';
export function FlightModificationDialog(_a) {
    var _b, _c;
    var { flightResult, hotelItinerary, selectHolidayFlight, flightSelected, onClose } = _a, other = __rest(_a, ["flightResult", "hotelItinerary", "selectHolidayFlight", "flightSelected", "onClose"]);
    const { isPageRouting } = usePageRouting();
    const flightCheckInAdjustment = flightResult === null || flightResult === void 0 ? void 0 : flightResult.checkInAdjustment;
    const flightId = (_b = flightResult === null || flightResult === void 0 ? void 0 : flightResult.flightId) !== null && _b !== void 0 ? _b : '';
    const newHotelSearchId = flightCheckInAdjustment === null || flightCheckInAdjustment === void 0 ? void 0 : flightCheckInAdjustment.dayDifferenceHotelSearchId;
    const newHotelProductId = flightCheckInAdjustment === null || flightCheckInAdjustment === void 0 ? void 0 : flightCheckInAdjustment.dayDifferenceHotelProductId;
    const newCheckInDate = flightCheckInAdjustment === null || flightCheckInAdjustment === void 0 ? void 0 : flightCheckInAdjustment.dayDifferenceHotelCheckIn;
    const dayDifferenceHotelNights = flightCheckInAdjustment === null || flightCheckInAdjustment === void 0 ? void 0 : flightCheckInAdjustment.dayDifferenceHotelNights;
    const { resourceStrings: { EXTENDEDFLIGHTSELECTIONMODALTITLE, EXTENDEDFLIGHTSELECTIONMODALTEXTSTART, EXTENDEDFLIGHTSELECTIONMODALTEXTEND, EXTENDEDFLIGHTSELECTIONMODALDURATIONINCREASE, EXTENDEDFLIGHTSELECTIONMODALDURATIONDECREASE, EXTENDEDFLIGHTSELECTIONMODALTIMELINEFROM, EXTENDEDFLIGHTSELECTIONMODALTIMELINETO, EXTENDEDFLIGHTSELECTIONMODALTIMELINENIGHTS, EXTENDEDFLIGHTSELECTIONMODALCANCELBUTTONLABEL, EXTENDEDFLIGHTSELECTIONMODALPROCEEDBUTTONLABEL, }, } = useGlobalContext();
    const { nights, checkInDate, checkOutDate } = hotelItinerary || {};
    const checkInNightDifference = flightCheckInAdjustment && (flightCheckInAdjustment === null || flightCheckInAdjustment === void 0 ? void 0 : flightCheckInAdjustment.dayDifferenceHotelNights);
    function increaseOrDecrease() {
        let nightString;
        if (Number(nights) > Number(checkInNightDifference)) {
            nightString = EXTENDEDFLIGHTSELECTIONMODALDURATIONDECREASE;
        }
        else {
            nightString = EXTENDEDFLIGHTSELECTIONMODALDURATIONINCREASE;
        }
        return nightString;
    }
    const dayDifferenceHotelCheckIn = flightCheckInAdjustment &&
        DateTime.fromISO((_c = flightCheckInAdjustment === null || flightCheckInAdjustment === void 0 ? void 0 : flightCheckInAdjustment.dayDifferenceHotelCheckIn) !== null && _c !== void 0 ? _c : '', { zone: 'UTC' }).toFormat('EEE dd MMM yyyy');
    const handleConfirmFlight = (event) => __awaiter(this, void 0, void 0, function* () {
        event.preventDefault();
        trackFunnelAction(FunnelAction.SELECT_FLIGHT, TripType.Holiday);
        const request = {
            flightId,
            newHotelSearchId,
            newHotelProductId,
            newCheckInDate,
            tripStateId: currentTripStateIdVar(),
        };
        selectHolidayFlight({
            request,
        });
    });
    return (React.createElement(Dialog, Object.assign({ dismissable: false, onClose: onClose, size: "m" }, other),
        React.createElement(DialogHeader, { HeadingProps: { 'data-id': 'data-id="flight_night_adjusted_title' }, border: false }, EXTENDEDFLIGHTSELECTIONMODALTITLE),
        React.createElement(DialogContent, null,
            React.createElement(Styler, { pt: 2, pb: 5 },
                React.createElement(TypographyBody, { mb: 5, "data-id": "flight_night_adjusted_text" }, `${EXTENDEDFLIGHTSELECTIONMODALTEXTSTART} ${increaseOrDecrease()} ${EXTENDEDFLIGHTSELECTIONMODALTEXTEND}`),
                React.createElement(Timeline, null,
                    React.createElement(TypographyBody, { size: "s" },
                        EXTENDEDFLIGHTSELECTIONMODALTIMELINEFROM,
                        ' ',
                        React.createElement("strong", { "data-id": "flight_night_adjusted_from" },
                            checkInDate,
                            " - ",
                            checkOutDate,
                            ' '),
                        "(",
                        React.createElement("span", { "data-id": "flight_night_adjusted_nights_from" }, nights),
                        ' ',
                        EXTENDEDFLIGHTSELECTIONMODALTIMELINENIGHTS,
                        ")"),
                    React.createElement(TypographyBody, { size: "s" },
                        EXTENDEDFLIGHTSELECTIONMODALTIMELINETO,
                        ' ',
                        React.createElement("strong", { "data-id": "flight_night_adjusted_to" },
                            dayDifferenceHotelCheckIn,
                            " - ",
                            checkOutDate,
                            ' '),
                        "(",
                        React.createElement("span", { "data-id": "flight_night_adjusted_nights_to" }, dayDifferenceHotelNights),
                        ' ',
                        EXTENDEDFLIGHTSELECTIONMODALTIMELINENIGHTS,
                        ")")),
                React.createElement(Styler, { mt: 6 },
                    React.createElement(FlexGrid, { container: true, spacing: 3 },
                        React.createElement(FlexGrid, { xs: 12, m: 6 },
                            React.createElement(Button, { "data-id": "flight_night_adjusted_proceed_btn", color: "callToAction", fullWidth: true, onClick: handleConfirmFlight, loading: flightSelected || isPageRouting }, EXTENDEDFLIGHTSELECTIONMODALPROCEEDBUTTONLABEL)),
                        React.createElement(FlexGrid, { xs: 12, m: 6 },
                            React.createElement(Button, { "data-id": "flight_night_adjusted_cancel_btn", color: "primary", variant: "outlined", fullWidth: true, onClick: () => onClose === null || onClose === void 0 ? void 0 : onClose(), disabled: flightSelected || isPageRouting }, EXTENDEDFLIGHTSELECTIONMODALCANCELBUTTONLABEL))))))));
}
